import { Controller } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';

const ControlledDatePicker = ({ name, control, rules, label, errors, sx = {}, ...props }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <DatePicker
          label={
            <>
              {label} <span style={{ color: '#ff6b6b' }}>*</span>
            </>
          }
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              fullWidth: true,
              sx: {
                backgroundColor: 'rgba(255,255,255,0.08)',
                borderRadius: '8px',
                "& .MuiInputBase-input": { color: "#fff" },
                "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.6)" },
                "& .MuiInputLabel-root.Mui-focused": { color: "#00ff88" },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.3)" },
                  "&:hover fieldset": { borderColor: "rgba(255,255,255,0.6)" },
                  "&.Mui-focused fieldset": { borderColor: "#00ff88" },
                },
                "& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.7)" },
                "& .MuiFormHelperText-root": { color: "#ff6b6b" },
                ...sx,
              },
              error: !!errors[name],
              helperText: errors[name]?.message || null,
            },
          }}
          {...props}
        />
      )}
    />
  );
};

export default ControlledDatePicker;
